import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  Input,
  Select,
} from "antd";
import { PlusOutlined, SearchOutlined, ToTopOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";

const { Title } = Typography;

// table code start
const columns = [
  {
    title: "COMPANY NAME",
    dataIndex: "companyName",
    key: "companyName",
    width: "32%",
  },

  // {
  //   title: "ACTIVE",
  //   key: "status",
  //   dataIndex: "status",
  // },
  {
    title: "COMPANY ID",
    key: "companyId",
    dataIndex: "companyId",
  },
];

const societatiPaza = [
  {
    label: "All Companies",
    value: "All Companies",
  },
  {
    label: "AKB SECURITY",
    value: "AKB SECURITY",
  },
  {
    label: "ELNET SECURITY",
    value: "ELNET SECURITY",
  },
  {
    label: "ORION SECURITY",
    value: "ORION SECURITY",
  },
  {
    label: "RPG SECURITY",
    value: "RPG SECURITY",
  },
  {
    label: "SSG SECURITY",
    value: "SSG SECURITY",
  },
  {
    label: "SSG FIRE&RESCUE",
    value: "SSG FIRE&RESCUE",
  },
  {
    label: "HIGHLANDER GUARD",
    value: "HIGHLANDER GUARD",
  },
];

function Companies() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState();

  const [selectedCompany, setSelectedCompany] = useState("All Companies");

  const [query, setQuery] = useState("");

  const data = companies
    ?.filter((company) =>
      query === ""
        ? company
        : company.companyName.toLowerCase().includes(query.toLowerCase())
    )
    // .filter((user) =>
    //   selectedCompany === "All Companies"
    //     ? user
    //     : user.company === selectedCompany
    // )
    .map((company) => {
      return {
        key: company?.id,
        companyName: (
          <>
            <Avatar.Group>
              {/*<Avatar*/}
              {/*  className="shape-avatar"*/}
              {/*  shape="square"*/}
              {/*  size={40}*/}
              {/*  src={face}*/}
              {/*></Avatar>*/}
              <div className="avatar-info">
                <Title level={5}>{company?.companyName}</Title>
                {/*<p>{?.email}</p>*/}
              </div>
            </Avatar.Group>{" "}
          </>
        ),
        // function: (
        //   <>
        //     <div className="author-info">
        //       <Title level={5}>Inspector</Title>
        //       <p>Premium Security</p>
        //     </div>
        //   </>
        // ),

        // status: (
        //   <>
        //     <Button
        //       className={user?.active ? "tag-primary" : "tag-badge"}
        //       style={{ cursor: "auto" }}
        //     >
        //       {user?.active ? <span>TRUE</span> : <span>FALSE</span>}
        //     </Button>
        //   </>
        // ),
        companyId: (
          <>
            <div className="ant-employed">
              <span>{company?.id}</span>
              <Link
                style={{ marginLeft: "10px", color: "#1EC8FF" }}
                to={`company/${company?.id}`}
              >
                Edit
              </Link>
            </div>
          </>
        ),
      };
    });

  const getCompanies = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "company/getAllCompanies",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setCompanies(response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedCompany(value);
  };

  const exportCompanies = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "csvExport/exportCompaniesToCSV?separator=%2C",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "companies.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Companies"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {/*<Select*/}
                  {/*  // defaultValue={societatiPaza[0].value}*/}
                  {/*  value={selectedCompany}*/}
                  {/*  style={{*/}
                  {/*    width: 200,*/}
                  {/*    marginRight: "10px",*/}
                  {/*    height: "100%",*/}
                  {/*    marginBottom: "10px",*/}
                  {/*    marginTop: "10px",*/}
                  {/*  }}*/}
                  {/*  onChange={handleChange}*/}
                  {/*  options={societatiPaza}*/}
                  {/*/>*/}
                  <Input
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    size="small"
                    prefix={
                      <SearchOutlined
                        size="small"
                        // style={{
                        //   backgroundColor: "red",
                        //   padding: "0px",
                        //   margin: "0px",
                        //   height: "10px",
                        // }}
                        className="site-form-item-icon"
                      />
                    }
                    placeholder="Search company"
                    onChange={(e) => setQuery(e.target.value)}
                    // style={{ width: 150, height: "100%" }}
                  />
                  <NavLink
                    to="/add-company"
                    style={{
                      marginBottom: "10px",
                      marginTop: "10px",
                      marginRight: "10px",
                    }}
                  >
                    <Button type="secondary" className="tag-primary">
                      <PlusOutlined />
                      Add Company
                    </Button>
                  </NavLink>
                  <Button
                    onClick={() => exportCompanies()}
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                    type="secondary"
                    className="tag-secondary"
                  >
                    Export Companies
                  </Button>
                  {/*<Input*/}
                  {/*  style={{ marginLeft: "20px" }}*/}
                  {/*  className="header-search"*/}
                  {/*  placeholder="Type here..."*/}
                  {/*  prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                {loading ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Companies;
